// Retain existing portal-service URLs and give unmapped services a distinct ID.
export const recommendationRouteId = (row) =>
  String(row.serviceId ?? `amis-${row.recommendation.serviceId}`);
